export const company = {
  state: {
    companies: []
  },
  mutations: {
    updateCompanies: function(state, newList) {
      state.companies = newList;
    },
    removeCompanies: function(state) {
      state.companies = [];
    } 
  },
  actions: {
    replaceCompanies: function({ commit }, newList) {
      commit("updateCompanies", newList);
    },
    clearCompanies: function({ commit }) {
      commit("removeCompanies");
    }    
  },
  getters: {
    getAllCompanies(state) {
      return state.companies;
    },
    getCompany(state) {
      return function(uuid) {
        return state.companies.find(function(a) {
          return (a.uuid === uuid)
        })
      }
    }
  }
}